var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_7544_5631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6353 17.871L15.7644 13.9984C18.6608 10.1278 17.871 4.64195 14.0004 1.74551C10.1297 -1.15092 4.6439 -0.361157 1.74747 3.50949C-1.14897 7.38013 -0.359203 12.866 3.51144 15.7624C6.62066 18.0891 10.8911 18.0891 14.0004 15.7624L17.873 19.635C18.3596 20.1216 19.1486 20.1216 19.6353 19.635C20.1219 19.1483 20.1219 18.3593 19.6353 17.8727L19.6353 17.871ZM8.78818 15.015C5.34814 15.015 2.55946 12.2263 2.55946 8.78623C2.55946 5.34618 5.34814 2.55751 8.78818 2.55751C12.2282 2.55751 15.0169 5.34618 15.0169 8.78623C15.0132 12.2247 12.2267 15.0113 8.78818 15.015Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7544_5631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0a0e9bbdc80f1fde45c31ccac04bc470.svg";
export { ForwardRef as ReactComponent };